import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogData } from '../data/blogData';
import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft, FiCalendar, FiClock, FiAlertCircle } from 'react-icons/fi';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogData.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen bg-[#f4f4f4] flex items-center justify-center px-6">
        <div className="bg-white border-4 border-black p-12 brutal-shadow text-center max-w-xl w-full">
          <div className="inline-flex items-center justify-center p-4 bg-black text-white mb-6">
            <SafeIcon icon={FiAlertCircle} className="w-12 h-12" />
          </div>
          <h1 className="text-4xl font-black uppercase mb-4">Post Not Found</h1>
          <p className="font-bold text-gray-600 mb-8 uppercase">The article you are looking for has been moved or deleted.</p>
          <Link to="/blog" className="inline-flex items-center gap-2 bg-black text-white border-2 border-black px-6 py-3 font-black uppercase brutal-shadow-sm brutal-hover transition-all">
            <SafeIcon icon={FiArrowLeft} /> Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <article className="min-h-screen bg-[#f4f4f4] py-12 md:py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <Link 
          to="/blog" 
          className="inline-flex items-center gap-2 font-black uppercase text-sm hover:underline underline-offset-4 decoration-2 mb-12"
        >
          <SafeIcon icon={FiArrowLeft} /> Back to Blog
        </Link>

        <div className="bg-white border-4 border-black p-8 md:p-12 brutal-shadow">
          <div className="flex flex-wrap items-center gap-4 text-xs font-black uppercase text-gray-400 mb-6">
            <div className="flex items-center gap-1">
              <SafeIcon icon={FiCalendar} /> {post.date}
            </div>
            <div className="flex items-center gap-1">
              <SafeIcon icon={FiClock} /> 8 MIN READ
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[1.1] mb-10">
            {post.title}
          </h1>

          <div 
            className="prose prose-xl max-w-none font-bold text-lg leading-relaxed text-gray-700 article-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <div className="mt-16 pt-12 border-t-4 border-black border-dashed flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-center md:text-left">
              <p className="text-xs font-black uppercase text-gray-400 tracking-widest mb-1">Author</p>
              <p className="font-black uppercase">ETERA EDITORIAL TEAM</p>
            </div>
            <Link to="/dashboard" className="bg-black text-white border-2 border-black px-10 py-5 font-black uppercase text-xl brutal-shadow-sm brutal-hover transition-all">
              Enter the Store Today
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        .article-content p { margin-bottom: 1.5rem; }
        .article-content h3 { 
          font-size: 2.25rem; 
          font-weight: 900; 
          text-transform: uppercase; 
          margin-top: 3.5rem; 
          margin-bottom: 1.5rem;
          line-height: 1.1;
          color: black;
          letter-spacing: -0.02em;
        }
        .article-content strong { font-weight: 900; color: black; }
        .article-content table {
          border-collapse: collapse;
          width: 100%;
        }
        .article-content th, .article-content td {
          padding: 1rem;
        }
        .article-content table tr:hover td {
          background-color: #f0f0f0;
        }
      `}</style>
    </article>
  );
};

export default BlogPost;